module.exports = __webpack_public_path__ + "static/media/thtplus-scb-banner.3e158ba7.jpg";